<template>
  <div class="warehouse">
    <div class="warehouse_head">
      <div class="warehouse_head_content">
        <div>
          <p style="font-size: 0.12rem; color: #ffffff; margin-bottom: 0.12rem">
            总云仓库存
          </p>
          <p style="font-size: 0.28rem; color: #efd7b1">
            {{ warehouse.num ? warehouse.num : 0 }}
          </p>
        </div>
        <p
          style="
            font-size: 0.12rem;
            text-decoration: underline;
            color: #efd7b1;
            text-decoration: underline;
          "
          @click="toInventoryDetail()"
        >
          库存明细
        </p>
      </div>
    </div>
    <div class="warehouse_content">
      <p style="height: 0.2rem; margin-bottom: 0.14rem; font-size: 0.14rem">
        商 品：{{ warehouse.shop_title?warehouse.shop_title:'--' }}
      </p>
      <p style="font-size: 0.14rem; color: #333333; height: 0.2rem">
        已提货：{{ warehouse.use ? warehouse.use : 0 }}
      </p>
    </div>

    <div class="warehouse_bottom_btn">
      <van-button plain type="primary" @click="toAddShop()">补货</van-button>
      <van-button plain type="primary" @click="toYunCang()"
        >云仓配货</van-button
      >
      <van-button plain type="primary" @click="toOffLine()"
        >提货到线下</van-button
      >
    </div>
  </div>
</template>

<script>
import { getMyInventory } from "../../api/home.js";
export default {
  data() {
    return {
      warehouse: {},
    };
  },
  methods: {
    toAddShop() {
      this.$router.push({
        name: "补货",
        params: {
          val: {
            shop_pic: this.warehouse.shop_pic,
            shop_title: this.warehouse.shop_title,
            shop_id: this.warehouse.shop_id,
            shop_price: this.warehouse.shop_price,
          },
        },
      });
    },
    toInventoryDetail(val) {
      this.$router.push({
        name: "库存明细",
      });
    },
    toYunCang() {
      this.$router.push({
        name: "云仓配货",
        params: {
          val: {
            shop_pic: this.warehouse.shop_pic,
            shop_title: this.warehouse.shop_title,
            shop_price: this.warehouse.shop_price,
          },
        },
      });
    },
    toOffLine() {
      this.$router.push({
        name: "提货到线下",
        params: {
          val: {
            shop_pic: this.warehouse.shop_pic,
            shop_title: this.warehouse.shop_title,
            shop_id: this.warehouse.shop_id,
            shop_price: this.warehouse.shop_price,
          },
        },
      });
    },
  },

  created() {
    getMyInventory().then((res) => {
      this.warehouse = res.data.backdata.warehouse;
    });
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#ffffff");
  },
  beforeDestroy() {
    document.querySelector("body").setAttribute("style", "background:#f3f1f4");
  },
};
</script>

<style lang='scss'>
.warehouse {
  padding-top: 0.48rem;

  .warehouse_head {
    padding: 0.1rem 0.15rem 0 0.15rem;
    width: 100%;
    height: 1.21rem;
    background: #f3f1f4;

    .warehouse_head_content {
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, #414141 0%, #2b2b2b 100%);
      border-radius: 0.08rem 0.08rem 0 0;
      padding: 0.27rem 0.28rem 0.26rem 0.27rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .warehouse_content {
    padding: 0.34rem 0 0.19rem 0.15rem;
  }

  .pickUp {
    .addShop_price {
      width: 3.45rem;
      height: 0.89rem;
      margin-top: 0.11rem;
      background: #ffffff;
      border-radius: 0.08rem;

      .van-cell--required::before {
        margin-left: 0.13rem;
        left: 0.03rem;
        font-size: 0.14rem;
      }

      .van-field__control {
        font-size: 0.14rem;
      }

      .onePrice {
        .van-field__control {
          color: #93683d;
        }
      }

      .van-field__label {
        margin-left: 0.17rem;
        color: #333333;
        font-size: 0.14rem;
      }
    }
  }

  .warehouse_bottom_btn {
    width: 100%;
    padding: 0 0.4rem;
    display: flex;
    justify-content: space-between;

    .van-button {
      padding: 0;
      text-align: center;
      width: 0.91rem;
      height: 0.29rem;
      border: 0.01rem solid #93683d;
      border-radius: 0.15rem;

      font-size: 0.13rem;
      color: #93683d;
    }
  }
}
</style>
